"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_GW_HOST = exports.API_GW_DOMAIN = void 0;
exports.API_GW_DOMAIN = "aws.api.snapchat.com";
exports.API_GW_HOST = "https://" + exports.API_GW_DOMAIN;
//# sourceMappingURL=urls.js.map